import styled from 'styled-components';

import { Button } from '@calm-web/design-system';

export const Wrapper = styled.div`
	background: rgba(0, 0, 0, 0.25);
	border-radius: 16px;
	margin-bottom: 24px;
	padding: 36px 24px;
`;

export const Form = styled.form`
	margin: 0 auto;
	max-width: 480px;
`;

export const SubmitButton = styled(Button)`
	margin: 24px 0 48px;
`;
